import { useEffect, useState } from "react";
import { api } from "../lib/api";
import BasketAnalyser from "../components/BasketAnalyser";
import DataAnalyst from "../components/DataAnalyst";
import StoreMultiSelect from "../components/StoreMultiSelect";
import { useAuth, homeStores } from "../context/AuthContext";

/**
 * Deeper analytical views — an open-ended "Ask the data" analyst (Table 18,
 * which prompts for dates itself when relevant), plus the permanent Basket
 * Analyser + Cross-sell playbook, each carrying its own inline date selector.
 * The page header keeps only the store filter (no global date range).
 */
export default function Analysis() {
  const { user } = useAuth();
  const [outlets, setOutlets] = useState([]);
  const [outletIds, setOutletIds] = useState(() => homeStores(user));

  useEffect(() => {
    api.get("/outlets").then(({ data }) => setOutlets(data)).catch(() => {});
  }, []);

  return (
    <div className="space-y-6" data-testid="analysis-page">
      <section className="flex items-baseline justify-between gap-6 flex-wrap">
        <div>
          <div className="bm-eyebrow text-neutral-500 mb-1">Toronto · Trends Desk</div>
          <h1 className="bm-headline text-4xl">Analysis</h1>
        </div>
        <div className="flex items-end gap-3 flex-wrap max-md:w-full">
          <StoreMultiSelect outlets={outlets} value={outletIds} onChange={setOutletIds} />
        </div>
      </section>

      {/* Ask the data — open-ended Claude analyst + shared question library */}
      <section>
        <DataAnalyst outlets={outlets} outletIds={outletIds} />
      </section>

      {/* Basket Analyser (includes Cross-sell playbook) — permanent, own date selector */}
      <section>
        <BasketAnalyser />
      </section>
    </div>
  );
}
